module.exports = __webpack_public_path__ + "media/images/logo-white-notext-73aa1cc90451e38a4b7a374e9b876c4c.png";